import { formatDate } from '@angular/common';

export default class Utils {
  static formattedDate(date?: string | number | Date): string {
    const newDate = date ? new Date(date) : new Date();
    return formatDate(
      new Date(
        newDate.getUTCFullYear(),
        newDate.getUTCMonth(),
        newDate.getUTCDate(),
        newDate.getUTCHours(),
        newDate.getUTCMinutes(),
        newDate.getUTCSeconds()
      ),
      'MM/dd/yyyy',
      'en-US'
    );
  }

  static readFileAsync(file: Blob): Promise<string | ArrayBuffer | null> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = () => {
        resolve(reader.result);
      };

      reader.onerror = reject;
      reader.readAsArrayBuffer(file);
    });
  }

  static deepClone<T>(obj: T): T {
    return JSON.parse(JSON.stringify(obj));
  }
}
